import BaseApplication from './base.js';

'use strict';

export class Application extends BaseApplication {
	constructor(args = []) {
		super(args);
		
		this.setLog('[Extension] ', "Experience Juuzenkai");
		
		this.setInteractiveMap();
	}

	callback() {
		this.showPerfomance();
		return null;
	}
	
	setInteractiveMap() {
		const self = this;
		
		this.mapping = {
			initialized: false,
			name: "MapTrigger",
			storage: [],
			wrapper: null,
			target: null,
			list: null,
			imageBasePath: "/wp-content/themes/chisan/public/img/experience/juuzenkai/all_s%ID%.jpg",
			options: null,
		}
		
		this.mapping.wrapper = document.getElementById("interactive-map");
		if(!this.isEmpty(this.mapping.wrapper)) {
			
			this.mapping.options = this.mapping.wrapper.getElementsByClassName("map-options")[0];
			this.mapping.target = this.mapping.wrapper.getElementsByClassName("map-target")[0];
			const mapSelector = this.mapping.wrapper.getElementsByClassName("map-selector")[0];
			if(!this.isEmpty(mapSelector) && !this.isEmpty(this.mapping.target)) {
				this.mapping.list = document.createElement("map");
				this.mapping.list.setAttribute("name", this.mapping.name);
				mapSelector.appendChild(this.mapping.list);
				
				this.mapping.target.setAttribute("id", "main-"+this.mapping.name);
				this.mapping.target.setAttribute("usemap", "#"+this.mapping.name);
			}
			
			this.mapping.list.addEventListener("mouseleave", function(event) {
				self.hoverInteractiveMap(0);
			});
			
			const mapElements = this.mapping.wrapper.getElementsByClassName("map-element");
			[].forEach.call(mapElements, function(mapElement) {
				var mapData = {
					el: mapElement,
					id: null,
					title: null,
					coord: null,
					shape: null,
				}
				
				var mapListItem = document.createElement("area");
				
				var mapID = mapElement.getAttribute("data-id");
				if(!self.isEmpty(mapID)) {
					mapData.id = mapID;
				}
				
				var mapTitle = mapElement.getAttribute("data-title");
				if(!self.isEmpty(mapTitle)) {
					mapData.title = mapTitle;
					mapListItem.setAttribute("href", "#"+mapData.title);
					mapListItem.setAttribute("alt", mapData.title);
				} else {
					mapListItem.setAttribute("href", "#");
				}
				
				var mapCoord = mapElement.getAttribute("data-map");
				if(!self.isEmpty(mapCoord)) {
					mapData.coord = mapCoord;
					mapListItem.setAttribute("coords", mapData.coord);
				}
				
				var mapShape = mapElement.getAttribute("data-shape");
				if(!self.isEmpty(mapShape)) {
					mapData.shape = mapShape;
					mapListItem.setAttribute("shape", mapData.shape);
				}
				
				mapListItem.addEventListener("mouseover", function(event) {
					self.hoverInteractiveMap(mapData.id);			
				});
				
				mapListItem.addEventListener("click", function(event) {
					event.preventDefault();
					self.triggerInteractiveMap(mapData);			
				});
				
				self.mapping.list.appendChild(mapListItem);
				self.mapping.storage.push(mapData);
				
				
				const mapLinks = self.mapping.wrapper.querySelectorAll("[data-view="+mapData.title+"]");
				[].forEach.call(mapLinks, function(mapLink) {
					mapLink.addEventListener("click", function(event) {
						event.preventDefault();
						self.triggerInteractiveMap(mapData);			
					})
				});
			});
			
			self.hoverInteractiveMap(0);
			self.triggerInteractiveMap(this.mapping.storage[0]);
			this.mapping.initialized = true;
		}
	}
	
	hoverInteractiveMap(mapDataID) {
		this.mapping.target.setAttribute("src", this.mapping.imageBasePath.replace("%ID%", (mapDataID != 0) ? mapDataID : ""));
	}
	
	triggerInteractiveMap(mapData) {
		const self = this;
		
		[].forEach.call(this.mapping.storage, function(mapElement) {
			mapElement.el.classList.remove("active");
		});
		mapData.el.classList.add("active");
		
		if(parseInt(mapData.id) == 0) {
			this.mapping.options.classList.remove("active");
		} else {
			this.mapping.options.classList.add("active");
		}
	}
};

window.Application = new Application();